import { hoursToMilliseconds, minutesToMilliseconds, secondsToMilliseconds } from 'date-fns';

export const HALF_SECOND = secondsToMilliseconds(0.5);

export const ONE_SECOND = secondsToMilliseconds(1);

export const TWO_SECONDS = secondsToMilliseconds(2);

export const THREE_SECONDS = secondsToMilliseconds(3);

export const FOUR_SECONDS = secondsToMilliseconds(4);

export const FIVE_SECONDS = secondsToMilliseconds(5);

export const TEN_SECONDS = secondsToMilliseconds(10);

export const TWENTY_SECONDS = secondsToMilliseconds(20);

export const THIRTY_SECONDS = secondsToMilliseconds(30);

export const ONE_MINUTE = minutesToMilliseconds(1);

export const TEN_MINUTES = minutesToMilliseconds(10);

export const FIVE_MINUTES = minutesToMilliseconds(5);

export const FIFTEEN_MINUTES = minutesToMilliseconds(15);

export const THIRTY_MINUTES = minutesToMilliseconds(30);

export const ONE_HOUR = hoursToMilliseconds(1);

export const TWELVE_HOURS = hoursToMilliseconds(12);

export const ONE_DAY = hoursToMilliseconds(24);

export const ONE_WEEK_IN_DAYS = 7;

export const ALWAYS_REFETCH = 0;

export const NO_CACHING = 0;
